import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6

import { Icon } from 'antd';

import obtenirConfiguracio from '../../configuracioEntorns';

const { BUCKET_S3_URL, FOLDER_S3 } = obtenirConfiguracio();
const idIniciImatgesLogin = 1;
const idFinalImatgesLogin = 30;

const obtenirEnterAleatoriMinMaxInclosos = (min, max)  => Math.floor(Math.random() * (max - min + 1)) + min;

class LoginImatges extends Component {

    render() {

        const idImatgeLogin = obtenirEnterAleatoriMinMaxInclosos(idIniciImatgesLogin, idFinalImatgesLogin);

        const urlImatge = `${BUCKET_S3_URL}/${FOLDER_S3}/imatges_login/${idImatgeLogin}.jpg`;
        const estils = {
            backgroundImage: `url(${urlImatge})`
        };

        return (
            <aside className='login-imatges' style={estils}>
                <a className="login-logo-gencat" title="Generalitat de Catalunya" href="http://web.gencat.cat/">gencat.cat</a>
                <ul className="xom-descripcio">
                    <li><Icon type='share-alt' /> Xarxa de col·laboradors</li>
                    <li><Icon type='cloud-o' /> Observacions meteorològiques</li>
                    <li><Icon type='video-camera' /> Vigilància meteorològica</li>
                </ul>
            </aside>
        );
    }
}

LoginImatges.propTypes = {
    children: PropTypes.element,
    location: PropTypes.object
};

export default LoginImatges;



// WEBPACK FOOTER //
// ./src/components/login/loginImatges.js